export function getNameOfTwoDaysMeeting(mArray) {
  const day1 = mArray[0].split(/[\s,]+/);
  const day2 = mArray[1].split(/[\s,]+/);
  if (day1[2] === day2[2]) {
    if (day1[0] === day2[0])
      return `${day1[0]} ${day1[1]} & ${day2[1]}, ${day1[2]}`;
    else {
      return `${day1[0].substring(0, 3)} ${day1[1]} & ${day2[0].substring(
        0,
        3
      )} ${day2[1]}, ${day1[2]}`;
    }
  } else {
    return `${day1[0].substring(0, 3)} ${day1[1]}, ${
      day1[2]
    } & ${day2[0].substring(0, 3)} ${day2[1]}, ${day2[2]}`;
  }
}
